import { forwardRef, SyntheticEvent, useState } from 'react'
import ErrorPicture from 'src/assets/imgs/Picture_loading_error.png'
import styled from 'styled-components'

export type ImageOption = {
  $ImgSrc?: string
  width?: string
  height?: string
  $margin?: string
  onClick?: () => void
  onError?: (e: SyntheticEvent<HTMLImageElement, Event>) => void
  className?: string
  style?: Object
  display?: string
  border_radius?: string
  visibility?: string
  $padding?: string
  $on_error_status?: string
}

const Image = forwardRef((props: ImageOption, ref?: React.Ref<HTMLImageElement>) => {
  const [onErrorStatus, setOnErrorStatus] = useState(false)
  return (
    <ImageWrap
      {...props}
      src={props.$ImgSrc}
      ref={ref}
      onClick={props.onClick}
      onError={(e: SyntheticEvent<HTMLImageElement, Event>) => {
        e.currentTarget.src = ErrorPicture
        setOnErrorStatus(true)
      }}
      $on_error_status={`${onErrorStatus}`}
    />
  )
})
export default Image

const ImageWrap = styled.img<ImageOption>`
  position: ${(props) => (props.$on_error_status === 'true' ? 'relative' : 'unset')};
  z-index: ${(props) => (props.$on_error_status === 'true' ? '1' : 'unset')};
  display: ${(props) => (props.display ? props.display : 'flex')};
  width: ${(props) => props.width};
  height: ${(props) => props.height};
  margin: ${(props) => props.$margin};
  padding: ${(props) => props.$padding};
  cursor: ${(props) => (props.onClick ? 'pointer' : 'default')};
  border-radius: ${(props) => props.border_radius};
  user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  -webkit-user-select: none;
`
